<template>
  <section>
    <form class="columns local-lm-filters-columns">
      <div class="column is-1">
        <store-filter
          v-bind="{ hasDisableStore }"
        />
      </div>
      <div class="column is-1 local-lm-filters-columns--fix-input">
        <order-number-filter
          v-bind="{ hasDisableOrderNumber }"
        />
      </div>
      <div class="column is-1 local-lm-filters-columns--fix-input">
        <order-bo-filter
          v-bind="{ hasDisableBo }"
        />
      </div>
      <div class="column is-1">
        <order-states-filter
          v-bind="{ hasOpenFilterOrderStates }"
        />
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-field>
          <b-datepicker
            :placeholder="$t('Filters.labelFilterCollectionDate')"
            :disabled="hasOpenFilterCollection"
            icon="dolly"
            v-model="collectionDates[0]"
            @click.native="activeFilterCollection"
            class="local-lm-filters-datepicker__filters-area"
            size="is-small"
            position="is-bottom-left"
            range
          />
        </b-field>
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-field>
          <b-datepicker
            :placeholder="$t('Filters.labelFilterPromisseDate')"
            :disabled="hasOpenFilterPromisse"
            v-model="promisseDates[0]"
            @click.native="activeFilterPromisse"
            icon="handshake"
            class="local-lm-filters-datepicker__filters-area"
            size="is-small"
            position="is-bottom-left"
            range
          />
        </b-field>
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-button
          class="lm-default-btn-outline-green--without-width lm-default-btn-delete"
          icon-right="close"
          size="is-small"
          @click.prevent="cleanFilters"
        />
        <b-button
          class="lm-default-btn-outline-green--without-width"
          icon-right="magnify"
          size="is-small"
          @click.prevent="submitData"
        />
      </div>
    </form>
  </section>
</template>

<script>
import { mixin } from '@/mixins'
import StoreFilter from '@/components/filters/StoreFilter'
import OrderNumberFilter from '@/components/filters/OrderNumberFilter'
import OrderBoFilter from '@/components/filters/OrderBoFilter'
import OrderStatesFilter from '@/components/filters/OrderStatesFilter'

export default {
  name: 'EdfFilters',
  beforeDestroy () {
    this.$eventBus.$off('sortOrders')
    this.$eventBus.$off('closeModal')
    this.$eventBus.$off('cleanFilters')
    this.$eventBus.$off('orderBoWrite')
    this.$eventBus.$off('onPageChange')
    this.$eventBus.$off('orderNumberWrite')
    this.$eventBus.$off('emptyOrders')
    this.$eventBus.$off('orders')
  },
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  components: {
    StoreFilter,
    OrderNumberFilter,
    OrderBoFilter,
    OrderStatesFilter
  },
  data () {
    return {
      collectionDates: [],
      promisseDates: [],
      hasDisableStore: false,
      hasDisableOrderNumber: false,
      hasDisableBo: false,
      hasOpenFilterOrderStates: false,
      hasOpenFilterCollection: false,
      hasOpenFilterPromisse: false
    }
  },
  mounted () {
    this.$eventBus.$on('orderBoWrite', flag => {
      this.hasDisableStore = flag
      this.hasDisableOrderNumber = flag
      this.hasOpenFilterOrderStates = flag
      this.hasOpenFilterCollection = flag
      this.hasOpenFilterPromisse = flag
    })

    this.$eventBus.$on('orderNumberWrite', flag => {
      this.hasDisableBo = flag
      this.hasOpenFilterOrderStates = flag
      this.hasOpenFilterCollection = flag
      this.hasOpenFilterPromisse = flag
    })

    this.$eventBus.$on('sortOrders', async (sortOption) => {
      this._getOrders(sortOption)
    })

    this.$eventBus.$on('closeModal', async () => {
      this._getOrders()
    })

    this.$eventBus.$on('onPageChange', async (page) => {
      this.$store.dispatch('filters/setPage', page)
      this._getOrders()
    })
  },
  methods: {
    async _getOrders (sort = null) {
      const filters = await this.$store.getters['filters/filtersSelected']
      if (sort) filters.sort = sort

      const orders = await this.$store.dispatch('orders/getEdfOrders', { filters })
      if (!orders.level) return this.wrong(this.$t(orders.errorText))

      const lengthOrders = this.$store.getters['orders/orders']
      if (orders && lengthOrders.length === 0) this.$eventBus.$emit('emptyOrders')
      if (orders && lengthOrders.length) this.$eventBus.$emit('orders')
    },

    async submitData () {
      const filters = await this.$store.getters['filters/filtersSelected']
      if (filters && filters.orderBo && isNaN(parseInt(filters.orderBo))) return this.wrong(this.$t('Errors.onlyNumerics'))

      this.$store.dispatch('filters/resetPage')

      if (this.promisseDates.length) {
        const flattenedArray = [].concat(...this.promisseDates)
        const dates = {
          promisseDateBegin: this.dateTimestamp(flattenedArray[0]),
          promisseDateEnd: this.dateTimestamp(flattenedArray[1])
        }

        this.$store.dispatch('filters/setPromisseDateSelected', dates)
      }

      if (this.collectionDates.length) {
        const flattenedArray = [].concat(...this.collectionDates)
        const dates = {
          collectionDateBegin: this.dateTimestamp(flattenedArray[0]),
          collectionDateEnd: this.dateTimestamp(flattenedArray[1])
        }

        this.$store.dispatch('filters/setCollectionDateSelected', dates)
      }

      this._getOrders()
    },
    cleanFilters () {
      this.collectionDates = []
      this.promisseDates = []

      this.hasDisableStore = false
      this.hasDisableOrderNumber = false
      this.hasDisableBo = false
      this.hasOpenFilterOrderStates = false
      this.hasOpenFilterCollection = false
      this.hasOpenFilterPromisse = false

      this.$store.dispatch('filters/flushUserFilters')
      this.$store.dispatch('orders/flush')
      this.$eventBus.$emit('cleanFilters')
    },
    activeFilterPromisse () {
      if (this.promisseDates.length) this.hasOpenFilterCollection = true
    },
    activeFilterCollection () {
      if (this.collectionDates.length) this.hasOpenFilterPromisse = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/EdfFilters.vue